import generalIcon from "assets/images/svg/Push Notifications.svg";
import bundleAssignmentsIcon from "assets/images/svg/bundleAssignments.svg";
import peopleIcon from "assets/images/svg/People24x24.svg";
import disconnectedIcon from "assets/images/svg/Disconnected.svg";
import starEmptyIcon from "assets/images/svg/Star-empty.svg";
import removeIcon from "assets/images/svg/remove-customers.svg";

export const TABS = {
  EDIT_BUNDLE: "EDIT_BUNDLE",
  BUNDLE_ASSIGNMENTS: "BUNDLE_ASSIGNMENTS",
  CUSTOMER_DIRECT: "CUSTOMER_DIRECT",
};

export const tabButtons = [
  {
    title: "General Settings",
    subTitle: "All settings applied for the current Bundle",
    key: TABS.EDIT_BUNDLE,
    icon: generalIcon,
  },
  {
    title: "Bundle Assignments",
    subTitle: "Set bundle target groups",
    key: TABS.BUNDLE_ASSIGNMENTS,
    icon: peopleIcon,
  },
  {
    title: "Customer Direct Assignment",
    subTitle: "Set bundle target customers",
    key: TABS.CUSTOMER_DIRECT,
    icon: bundleAssignmentsIcon,
  },
];

export const STATUS_COLOR_MAP = {
  Active: {
    color: "#17C347",
    backgroundColor: "#D8FFE3",
  },
  Inactive: {
    color: "#FF0000",
    backgroundColor: "#FF00001A",
  },
  New: {
    color: "#DB6607",
    backgroundColor: "#DB660726",
  },
  Pending: {
    color: "#0085FF",
    backgroundColor: "#0085FF26",
  },
};

export const STATUS_COLOR_MAP_ASSIGNMENTS = {
  Active: {
    color: "#17C347",
    backgroundColor: "#D8FFE3",
  },
  Pending: {
    color: "#DB6607",
    backgroundColor: "#DB660726",
  },
};

export const VALIDATION_RULES = [{ required: true, message: "Please enter value" }];

export const ASSIGNMENTS_TYPES = ["Default", "Depot", "CustomerGroup"];

export const REGISTRATION_CATEGORY_LIST = ["Residential", "Commercial"];

export const BUNDLE_ASSIGNMENT_ACTIONS = {
  ASSIGN: "Assign",
  RE_ASSIGN: "Re-assign",
  UN_ASSIGN: "Un-assign",
  SET_AS_PRIMARY: "Set as Primary",
  REMOVE_PRIMARY: "Remove Primary",
  EDIT: "Edit",
};

export const ICONS_MAP = {
  [BUNDLE_ASSIGNMENT_ACTIONS.REMOVE_PRIMARY]: disconnectedIcon,
  [BUNDLE_ASSIGNMENT_ACTIONS.RE_ASSIGN]: starEmptyIcon,
  [BUNDLE_ASSIGNMENT_ACTIONS.SET_AS_PRIMARY]: starEmptyIcon,
  [BUNDLE_ASSIGNMENT_ACTIONS.ASSIGN]: starEmptyIcon,
  [BUNDLE_ASSIGNMENT_ACTIONS.UN_ASSIGN]: removeIcon,
};
